import { type ApiError, type PageInfoWithCursor } from '@setplex/tria-api'
import { createEvent, sample, type Effect, type Store } from 'effector'
import { and, not } from 'patronum'

export const getNextPage = (
  store: Store<PageInfoWithCursor | null>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  effect: Effect<any, any, ApiError>
) => {
  const event = createEvent()
  const $isLast = store?.map((data) => data?.last ?? null)

  sample({
    clock: event,
    source: store,
    filter: and(not(effect.pending), not($isLast)),
    fn: (store) => {
      // TODO: Temporary solution (trim symbols '=') until it is fixed on the backend
      const cursorTrimmed = store?.nextCursor?.replaceAll('=', '')

      return {
        count: store?.size,
        cursor: cursorTrimmed,
      }
    },
    target: effect,
  })

  return event
}
